export default "__VITE_ASSET__ySmVFfMr__"